/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2023-10-18 10:02:04
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Modal,
  notification,
  Radio,
  Row,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import _ from 'lodash'
import { Tenant } from '../../../models/tenant'
import { Checks, Settinglable } from '../../../models/setting'
import { getSettingDetail, saveSettingLabel, selectSettings, selectTenant } from '../../user/setting/settingSlice'
import styles from './doctoAchievement.module.css'

interface SettingsComputeModeModalProps {
  viewType?: string
  visible?: boolean
  onOk?: () => void
  onCancel?: () => void
}
export const SettingsComputeModeModal = ({
  viewType,
  onOk,
  onCancel,
  visible,
}: SettingsComputeModeModalProps): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const tenant = useSelector(selectTenant)
  const settings = useSelector(selectSettings)

  const [buttonLoading, setButtonLoading] = useState(false)

  // 打开弹窗时拉取最新设置
  useEffect(() => {
    if (visible) {
      dispatch(getSettingDetail())
    }
  }, [visible, dispatch])

  // 当 settings 变化时回填表单值
  useEffect(() => {
    if (settings) {
      form.setFieldsValue({
        [Checks.SFXMJEJSFS]: settings[Checks.SFXMJEJSFS] ? Number(settings[Checks.SFXMJEJSFS]) : 1,
        // [Checks.GHFJSFS]: settings[Checks.GHFJSFS] ? Number(settings[Checks.GHFJSFS]) : 1,
        [Checks.ZFJEJSFS]: settings[Checks.ZFJEJSFS] ? Number(settings[Checks.ZFJEJSFS]) : 1,
      })
    }
  }, [settings, form])


  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  return (
    <Modal
      visible={visible}
      title='设置'
      width={700}
      maskClosable={false}
      destroyOnClose
      style={{ overflow: 'hidden', padding: '0' }}
      bodyStyle={{ padding: '10px 15px 15px 25px' }}
      onCancel={onCancel}
      onOk={() => form.submit()}
      confirmLoading={buttonLoading}
    >
      <Form
        form={form}
        {...layout}
        initialValues={{
          [Checks.SFXMJEJSFS]: 1,
          // [Checks.GHFJSFS]: 1,
          [Checks.ZFJEJSFS]: 1,
        }}
        onFinish={(values) => {
          const pattern = /^[0-9]*$/

          const t = _.chain(values)
            .omitBy((_, k) => pattern.test(k))
            .value() as Tenant

          const f = _.chain(values)
            .pickBy((_, k) => pattern.test(k))
            .mapValues(
              (v, k) =>
              ({
                type: k,
                value: v?.toString(),
              } as Settinglable)
            )
            .values()
            .value()
          setButtonLoading(true)
          dispatch(
            saveSettingLabel({
              tenant: {
                ...tenant,
                ...t,
              },
              functionList: f,
            })
          )
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: '保存成功',
                duration: 3,
              })
              dispatch(getSettingDetail())
              onOk && onOk()
            })
            .catch(() => {
              notification.error({ message: '机构设置保存失败', duration: 3 })
              dispatch(getSettingDetail())
            })
            .finally(() => {
              setButtonLoading(false)
            })
        }}
      >
        <div style={{ overflow: 'auto' }}>
          <div style={{ marginTop: '20px' }}>
            {/* 1. 收费项目金额计算方式 */}
            {viewType == 'summary' ? <>
              {/* 3. 自费金额计算方式 */}
              < Form.Item label='自费金额计算方式' name={Checks.ZFJEJSFS}>
                <Radio.Group style={{ display: 'flex', flexDirection: 'column' }}>
                  <Radio value={1} style={{ marginTop: 5, height: '32px' }}>
                    补交金额统计在补交日
                  </Radio>
                  <Radio value={2} style={{ height: '32px' }}>
                    补交金额统计在首次结算日
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </>
              : <div style={{ position: 'relative' }}>
                <Form.Item label='收费项目金额计算方式' name={Checks.SFXMJEJSFS} style={{ marginBottom: 2 }}>
                  <Radio.Group style={{ display: 'flex', flexDirection: 'column' }}>
                    <Radio value={1} style={{ marginTop: 5 }}>
                      按实收进行提成
                      <div className={styles.tipsTwo}>
                        实收：已计算折扣、优惠的价格
                      </div>
                    </Radio>
                    <Radio value={2} >
                      按原价进行提成
                      <div className={styles.tipsTwo}>
                        原价：未计算折扣、优惠的原始价格
                      </div>
                    </Radio>
                  </Radio.Group>
                </Form.Item>
                {/* <span style={{ position: 'absolute', top: '24px', left: '8px', color: '#8c8c8c', fontSize: '14px' }}>（排除挂号费）</span> */}
              </div>
            }

            {/* 2. 挂号费计算方式 */}
            {/* <Form.Item label='挂号费计算方式' name={Checks.GHFJSFS} style={{ marginBottom: 2 }}>
              <Radio.Group style={{ display: 'flex', flexDirection: 'column' }}>
                <Radio value={1} style={{ marginTop: 5 }}>
                  按实收进行提成
                  <div className={styles.tipsTwo}>
                    实收：已计算折扣、优惠的价格
                  </div>
                </Radio>
                <Radio value={2} >
                  按原价进行提成
                  <div className={styles.tipsTwo}>
                    原价：未计算折扣、优惠的原始价格
                  </div>
                </Radio>
              </Radio.Group>
            </Form.Item> */}


          </div>
        </div>
      </Form>
    </Modal >
  )
}
